import {
    RaikoGridOneColumn,
    RaikoDatePicker,
    RaikoMoneyInputOutlined,
    RaikoButtonPrimary,
    RaikoFlexAlignEnd,
    showErrorMessage,
    showSuccessMessage
} from "@moeindal/base-raiko-panel-components"
import {useEffect, useState} from "react";
import {css} from "@emotion/css";
import {UnionService} from "../../serverService/unionService/UnionService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {convertUniversalDateToPersianDate} from "../../util/DateConvertor";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {useParams} from "react-router-dom";

export default function UnionInfo({
                                      transactionId,
                                      handleAddNewItem,
                                      handleUpdateTransactionInTable,
                                      handleCloseDialog
                                  }) {

    const [transactionDate, setTransactionDate] = useState("");
    const [amount, setAmount] = useState("");
    const [buttonTitle, setButtonTitle] = useState("افزودن");
    const [buttonLoading, setButtonLoading] = useState(false)

    const service = new UnionService()
    const loading = new LoadingHelper(useLoadingDispatcher())
    const {id: fundId} = useParams()


    useEffect(() => {
        if (typeof service !== 'undefined') {
            getUnitTransactionInfoFromServer()
        }
    }, []);
    useEffect(() => {
        if (transactionId >= 0) {
            getUnitTransactionInfoFromServer()
            setButtonTitle("بروزرسانی")
        }
    }, [transactionId]);

    function getUnitTransactionInfoFromServer() {
        loading.show()
        service.getUnitTransactionInfo(transactionId).then(
            response => {
                setAmount(response.amount)
                setTransactionDate(convertUniversalDateToPersianDate(response.date))
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleAddNewTransaction() {
        setButtonLoading(true)
        service.addNewTransaction(fundId, amount, transactionDate).then(
            response => {
                showSuccessMessage("تراکنش جدید با موفقیت افزوده شد.")
                handleAddNewItem(response)
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setButtonLoading(false)
        })
    }

    function handleUpdateTransaction() {
        setButtonLoading(true)
        service.updateTransaction(transactionId, amount, transactionDate).then(
            response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                handleUpdateTransactionInTable(transactionId, response.amount, response.date)
                handleCloseDialog()
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setButtonLoading(false)
        })

    }

    function performOperations() {
        if (transactionId >= 0) {
            handleUpdateTransaction()
        } else {
            handleAddNewTransaction()
        }
    }

    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem;`}>
            <RaikoDatePicker
                date={transactionDate}
                setDate={setTransactionDate}
                label={"تاریخ واریز"}
            />
            <RaikoMoneyInputOutlined
                labelText={"مبلغ (ریال)"}
                value={amount}
                setValue={setAmount}
            />
            <RaikoFlexAlignEnd>
                <RaikoButtonPrimary loading={buttonLoading} label={buttonTitle} onClick={performOperations}/>
            </RaikoFlexAlignEnd>


        </RaikoGridOneColumn>
    )
}